import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const productMappingProductSchema = z.object({
  id: z.string(),
  title: z.string(),
  sku: z.string().nullable(),
  imageUrl: z.string().nullable(),
  shopifyAdminUrl: z.string().nullable(),
});
export type ProductMappingProduct = z.infer<typeof productMappingProductSchema>;

export const productMappingSchema = z.object({
  product: productMappingProductSchema,
  alternateProduct: productMappingProductSchema,
});
export type ProductMapping = z.infer<typeof productMappingSchema>;

export const listProductMappings = unaryRpc({
  name: "listProductMappings" as const,
  input: z.object({
    source: z.enum(["shopify", "commentsold"]).optional(),
    search: z.string().optional(),
    page: z.number().int().min(0).optional(),
    pageSize: z.number().int().min(1).max(500).optional(),
  }),
  output: z.object({
    mappings: z.array(productMappingSchema),
    totalCount: z.number(),
  }),
});

export const searchProductForMappingSchema = productMappingProductSchema.extend(
  { isMapped: z.boolean() },
);
export type SearchProductForMapping = z.infer<
  typeof searchProductForMappingSchema
>;

export const searchProductsForMapping = unaryRpc({
  name: "searchProductsForMapping" as const,
  input: z.object({
    query: z.string(),
    source: z.enum(["shopify", "commentsold"]).optional(),
    limit: z.number().int().min(1).max(100).optional(),
  }),
  output: z.object({ products: z.array(searchProductForMappingSchema) }),
});

export const createProductMapping = unaryRpc({
  name: "createProductMapping" as const,
  input: z.object({
    productId: z.string().regex(/^[1-9]\d*$/),
    alternateProductId: z.string().regex(/^[1-9]\d*$/),
  }),
  output: z.object({ mapping: productMappingSchema }),
});

export const deleteProductMapping = unaryRpc({
  name: "deleteProductMapping" as const,
  input: z.object({ productId: z.string().regex(/^[1-9]\d*$/) }),
  output: z.object({ ok: z.literal(true) }),
});
